<template>
	<Head title="Aulas"></Head>

	<div class="card mb-4 shadow-sm">
		<div class="card-header">
			<h3 class="card-title">
				<span class="fa fa-layer-group"></span>&nbsp;&nbsp; Aulas
			</h3>
		</div>
	</div>
	<div v-if="props.classReady">
		<div class="row">
			<div class="col-12">
				<div class="card my-4 shadow-sm">
					<div class="card-header">
						<div class="card_dash_left1 align-self-center">
							<h3 class="card-title">
								<span class="fa fa-clock me-2"></span>
								Proxima aula
							</h3>
						</div>
					</div>
					<div class="card-body">
						<div class="row gy-2">
							<div class="col-sm-12 col-md">
								<div>
									<b>Previsão de início da aula</b>
								</div>
								<div>
									{{
										new Date(
											props.classReady.start_at
										).toLocaleString('pt-br')
									}}
								</div>
							</div>

							<div class="col-sm-12 col-md">
								<div>
									<b>Situação do aluno</b>
								</div>
								<div
									:class="`badge badge-${props.user_state_color}`">
									{{ props.user_state_text }}
								</div>
							</div>
							<div class="col-sm-12 col-md">
								<div>
									<b>Situação da aula</b>
								</div>

								<div
									:class="`badge badge-${props.class_state_color}`">
									{{ props.class_state_text }}
								</div>
							</div>
							<div class="col-sm-12 col-md">
								<div>
									<b>Número de aulas</b>
								</div>
								<div>
									{{ props.classReady.number_of_classes }}
								</div>
							</div>
							<div class="col-sm-12 col-md">
								<div>
									<b>Instrutor</b>
								</div>
								<div>
									{{ props.classReady.instructor_name }}
								</div>
							</div>
							<div class="col-sm-12 col-md">
								<a
									v-if="props.class_online"
									type="button"
									class="btn btn-success btn-block"
									:href="props.zoom_class_url"
									title="Gerenciamento de aula">
									Entrar na aula
								</a>
								<a
									v-else-if="
										props.class_online === null &&
										props.zoom_class_url === null
									"
									type="button"
									:class="disabled_button"
									title="Aula Indisponível">
									Aula Indisponível
								</a>
								<a
									v-else
									type="button"
									class="btn btn-primary btn-block"
									href="#"
									title="Gerenciamento de aula">
									Aula finalizada
								</a>
							</div>
							<div class="col-12" v-if="props.classReady.class.attachments?.length > 0">
								<div>
									<b>Material de estudo da aula</b>
								</div>
								<div>
									<ul>
										<li v-for="attachment in props.classReady.class.attachments" :key="attachment.id">
											<a
												:href="attachment.url"
												class="text-decoration-none"
												target="_blank">
												{{ attachment.description }}
											</a>

										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-else class="alert alert-info">Não possui aulas cadastradas</div>
	<div class="card mt-4 shadow-sm">
		<a data-bs-toggle="collapse" href="#collapseExample" role="button">
			<div class="card-header">
				<div class="card_dash_left1 align-self-center">
					<h3 class="card-title">
						<span class="fa fa-book me-2"></span>
						Historico de aulas
					</h3>
				</div>
				<div class="card_dash_right1 align-self-center">
					<i class="fa fa-angle-double-down fa-2x"></i>
				</div>
			</div>
		</a>
	</div>
	<div id="collapseExample" v-if="props.classesHistory">
		<div class="row">
			<div class="col-12">
				<div
					class="card my-4 shadow-sm"
					v-for="record in props.classesHistory.data">
					<div class="card-body">
						<div class="row gy-2">
							<div class="col-12 col-lg-3">
								<div>
									<b>Horário aproximado de início da aula</b>
								</div>
								<div>
									{{
										new Date(
											record.start_at
										).toLocaleString('pt-br')
									}}
								</div>
							</div>
							<div class="col-12 col-lg-3">
								<div>
									<b>Situação do aluno</b>
								</div>
								<div
									:class="`badge badge-${record.student_status_color}`">
									{{ record.student_status_text }}
								</div>
							</div>
							<div class="col-12 col-lg-3">
								<div>
									<b>Número de aulas</b>
								</div>
								<div>
									{{ record.number_of_classes }}
								</div>
							</div>
							<div class="col-12 col-lg-3">
								<div>
									<b>Instrutor</b>
								</div>
								<div>
									{{ record.instructor_name }}
								</div>
							</div>
							<div class="col-12" v-if="record.class.attachments?.length > 0">
								<div>
									<b>Material de estudo da aula</b>
								</div>
								<div>
									<ul>
										<li v-for="attachment in record.class.attachments" :key="attachment.id">
											<a
												:href="attachment.url"
												class="text-decoration-none"
												target="_blank">
												{{ attachment.description }}
											</a>

										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					class="d-flex mb-5 align-self-center"
					v-if="has_classes_history">
					<a
						:href="props.classesHistory.prev_page_url"
						v-if="props.classesHistory.prev_page_url !== null"
						:class="enabled_button"
						class="me-3">
						« Anterior
					</a>
					<span class="me-3" v-else :class="disabled_button">
						« Anterior
					</span>
					<a
						:href="props.classesHistory.next_page_url"
						v-if="props.classesHistory.next_page_url !== null"
						:class="enabled_button">
						Próximo »
					</a>
					<span v-else :class="disabled_button"> Próximo » </span>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { Head } from '@inertiajs/vue3';

	const props = defineProps({
		classReady: { type: Object, required: true },
		classesHistory: { type: Object, required: true },
		user_state_color: { type: String, required: true },
		user_state_text: { type: String, required: true },
		class_state_text: { type: String, required: true },
		class_state_color: { type: String, required: true },
		class_online: { type: Boolean, required: true },
		zoom_class_url: { type: String, required: true },
	});

	const has_classes_history = props.classesHistory.data.length > 0;
	const disabled_button =
		'relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 cursor-default leading-5 rounded-md';
	const enabled_button =
		'relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 rounded-md hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150';
</script>
